import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { type Board, type Clip } from '@air/api/types';
import { selectItemAction } from '@air/redux-selected-items';

import { stopMultiselectEscKeyPropagation } from '~/components/MultiselectKeys';
import { focusRowElement } from './rowUtils';

export const useEscapeKeyHandler = (
  showMenu: boolean,
  rowIsSelected: boolean,
  menuIsOpen: boolean,
  item: Clip | Board,
) => {
  const dispatch = useDispatch();

  const onEscapeKeyDown = useCallback(() => {
    if (showMenu) {
      if (rowIsSelected) {
        dispatch(selectItemAction({ item }));
      }
      focusRowElement(item.id);
    }
  }, [dispatch, showMenu, rowIsSelected, item]);

  useEffect(() => {
    stopMultiselectEscKeyPropagation(menuIsOpen);
  }, [menuIsOpen]);

  return onEscapeKeyDown;
};
